import React from 'react';
import { GiCheckMark } from 'react-icons/gi';

export default function BookingConfirmation() {
     return (
          <div className='w-full max-w-2xl mx-auto text-center'>
               <div className='bg-white rounded-2xl p-8 border border-gray-200 shadow-sm'>
                    <div className='w-20 h-20 rounded-full bg-yellow/20 flex items-center justify-center mx-auto mb-5'>
                         <GiCheckMark className='text-yellow text-3xl' />
                    </div>

                    <h3 className='text-dark uppercase font-bold text-[28px] laptop:text-[36px] leading-tight mb-3'>
                         Booking Request Received!
                    </h3>
                    <p className='text-darker/70 mb-6'>
                         Thanks! We received your booking request and will reach out shortly to confirm availability and collect payment.
                    </p>

                    <div className='bg-gray-50 rounded-xl p-5 mb-6 text-left border border-gray-200'>
                         <h4 className='text-yellow text-xs uppercase tracking-widest font-bold mb-3'>
                              What's Next
                         </h4>
                         <ul className='space-y-2 text-darker text-base'>
                              <li>1. We'll call or email within 1 business day to confirm</li>
                              <li>2. We'll arrange payment (card, check, or cash)</li>
                              <li>3. Review the safety manuals on our Safety page</li>
                              <li>4. Equipment will be ready on your start date</li>
                         </ul>
                    </div>

                    <div className='flex flex-col tablet:flex-row gap-3 justify-center'>
                         <a
                              href='/'
                              className='py-3 px-6 rounded-xl border-2 border-gray-200 text-darker/60 font-semibold hover:border-darker/30 hover:text-darker duration-300 text-center'
                         >
                              Back to Home
                         </a>
                         <a
                              href='/safety'
                              className='group relative font-semibold text-base uppercase tracking-wider bg-yellow text-dark pl-10 pr-6 py-4 rounded-xl hover:bg-yellow/90 duration-300 flex items-center justify-center whitespace-nowrap'
                         >
                              <span className='text-dark pr-2 absolute left-4 duration-300 group-hover:tracking-[0.15em]'>
                                   {'//'}
                              </span>
                              Safety Manuals
                         </a>
                    </div>
               </div>
          </div>
     );
}
